import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
let userss={"id":0,"firstname":"","lastname":"","email":"","password":"","customerid":"","photo":"","phone":"","referenceid":"","username":""}
let user=JSON.parse(localStorage.getItem("customer"))
if(user){
  if(user.id>0){
    userss=user
  }
}
let admin=false
let auth=false
let checkadmin=localStorage.getItem("admin")
let checkauth=localStorage.getItem("auth")
console.log("checkauth",checkauth)
console.log(typeof checkauth)
if(checkauth=='true'){
  auth=true
}
if(checkadmin==true){
  admin=true
}
export default new Vuex.Store({
  state: {
    cart:[],
    totalprice:0,
    stat:"",
    customer:userss,
    auth:auth,
    orders:[],
    admin:admin
  },
  mutations: {
    addToCart(state,item){
      state.cart.push(item)
    },
    addTotalPrice(state,price){
      state.totalprice=price
    },
    removeCart(state){
      state.cart=[]
    },
    setStat(state,stat){
      state.stat=stat
    },
    setCustomer(state,cust){
      state.customer=cust
    },
    setAuth(state,auth){
      state.auth=auth
    },
    setOrder(state,order){
      state.orders=order
    },
    setAdmin(state,admin){
      state.admin=admin
    }
  },
  actions: {
  },
  modules: {
  }
})
